/**
 * Please note:
 *
 * Translations are provided as an illustration only and are
 * not guaranteed to be accurate or error-free.
 *
 * They are designed to show developers where to store their
 * chosen phrase or spelling variant in the target language.
 */

export const AG_CHARTS_LOCALE_SV_SE: Record<string, string> = {
    ariaAnnounceChart: 'diagram, ${seriesCount}[number] serier',
    ariaAnnounceFlowProportionLink: 'länk ${index} av ${count}, från ${from} till ${to}, ${sizeName} ${size}',
    ariaAnnounceFlowProportionNode: 'nod ${index} av ${count}, ${description}',
    ariaAnnounceGaugeChart: 'mätargraf, ${caption}',
    ariaAnnounceHierarchyChart: 'hierarkidiagram, ${caption}',
    ariaAnnounceHierarchyDatum: 'nivå ${level}[number], ${count}[number] barn, ${description}',
    ariaAnnounceHoverDatum: '${datum}',
    ariaDescriptionLegendItem: 'Tryck på Space eller Enter för att växla synlighet',
    ariaLabelAddHorizontalLine: 'Lägg till horisontell linje',
    ariaLabelAnnotationOptionsToolbar: 'Alternativ för annotering',
    ariaLabelAnnotationSettingsDialog: 'Inställningar för anteckningar',
    ariaLabelColorPicker: 'Färgväljare',
    ariaLabelFinancialCharts: 'Finansiella diagram',
    ariaLabelLegend: 'Teckenförklaring',
    ariaLabelLegendItem: '${label}, Legend objekt ${index}[number] av ${count}[number]',
    ariaLabelLegendItemUnknown: 'Okänd legendpost',
    ariaLabelLegendPageNext: 'Nästa legend sida',
    ariaLabelLegendPagePrevious: 'Föregående legendasida',
    ariaLabelLegendPagination: 'Legend Paginerings',
    ariaLabelNavigator: 'Navigator',
    ariaLabelNavigatorMaximum: 'Maximal',
    ariaLabelNavigatorMinimum: 'Minsta',
    ariaLabelNavigatorRange: 'Räckvidd',
    ariaLabelRangesToolbar: 'Områden',
    ariaLabelSettingsTabBar: 'Inställningar',
    ariaLabelZoomToolbar: 'Zooma',
    ariaValuePanRange: '${min}[percent0to2dp] till ${max}[percent0to2dp]',
    contextMenuDownload: 'Ladda ner',
    contextMenuPanToCursor: 'Panorera hit',
    contextMenuToggleOtherSeries: 'Växla andra serier',
    contextMenuToggleSeriesVisibility: 'Växla synlighet',
    contextMenuZoomToCursor: 'Zooma hit',
    dialogHeaderChannel: 'Kanal',
    dialogHeaderDatePriceRange: 'Datum och pris',
    dialogHeaderDateRange: 'Datumintervall',
    dialogHeaderFibonacciRange: 'Fib Återhämtning',
    dialogHeaderLine: 'Linje',
    dialogHeaderPriceRange: 'Prisklass',
    dialogHeaderText: 'Text',
    dialogInputAlign: 'Justering',
    dialogInputColorPicker: 'Färg',
    dialogInputColorPickerAltText: 'Textfärg',
    dialogInputExtendAbove: 'Förläng ovan',
    dialogInputExtendBelow: 'Förläng nedanför',
    dialogInputExtendChannelEnd: 'Förläng kanalens slut',
    dialogInputExtendChannelStart: 'Utöka kanalstart',
    dialogInputExtendLeft: 'Förläng åt vänster',
    dialogInputExtendLineEnd: 'Förläng linjens slut',
    dialogInputExtendLineStart: 'Förläng linjens start',
    dialogInputExtendRight: 'Sträck ut åt höger',
    dialogInputFibonacciBands: 'Bander',
    dialogInputFibonacciBandsAltText: 'Fibonacci-band',
    dialogInputFillColorPicker: 'Fyll',
    dialogInputFillColorPickerAltText: 'Fyllnadsfärg',
    dialogInputFontSize: 'Storlek',
    dialogInputFontSizeAltText: 'Teckenstorlek',
    dialogInputLineStyle: 'Streck',
    dialogInputPosition: 'Position',
    dialogInputReverse: 'Omvänd',
    dialogInputShowFill: 'Visa fyllning',
    dialogInputStrokeWidth: 'Vikt',
    dialogInputStrokeWidthAltText: 'Linjens vikt',
    iconAltTextAlignCenter: 'Centrera',
    iconAltTextAlignLeft: 'Vänster',
    iconAltTextAlignRight: 'Höger',
    iconAltTextClose: 'Stäng',
    iconAltTextLineStyleDashed: 'Långstreckad',
    iconAltTextLineStyleDotted: 'Kortstreckad',
    iconAltTextLineStyleSolid: 'Solid',
    iconAltTextPositionBottom: 'Botten',
    iconAltTextPositionCenter: 'Center',
    iconAltTextPositionTop: 'Topp',
    inputTextareaPlaceholder: 'Lägg till text',
    measurerDateRangeBars: '${value}[number] staplar',
    measurerPriceRangePercent: '${value}[percent]',
    measurerPriceRangeValue: '${value}[number]',
    measurerVolume: 'Vol ${value}',
    overlayLoadingData: 'Laddar data...',
    overlayNoData: 'Inga data att visa',
    overlayNoVisibleSeries: 'Inga synliga serier',
    overlayUnsupportedBrowser: 'Inkompatibel webbläsarversion. Var god uppgradera din webbläsare.',
    seriesHistogramTooltipCount: '${yName} (antal)',
    seriesHistogramTooltipFrequency: 'Frekvens',
    seriesHistogramTooltipMean: '${yName} (medelvärde)',
    seriesHistogramTooltipSum: '${yName} (summa)',
    toolbarAnnotationsArrow: 'Pil',
    toolbarAnnotationsArrowDown: 'Pilen ned',
    toolbarAnnotationsArrowUp: 'Pil Upp',
    toolbarAnnotationsCallout: 'Anmärkning',
    toolbarAnnotationsClearAll: 'Rensa alla',
    toolbarAnnotationsComment: 'Kommentar',
    toolbarAnnotationsDatePriceRange: 'Datum och pris',
    toolbarAnnotationsDateRange: 'Datumintervall',
    toolbarAnnotationsDelete: 'Ta bort',
    toolbarAnnotationsDisjointChannel: 'Oberoende Kanal',
    toolbarAnnotationsDragHandle: 'Dra Verktygsfält',
    toolbarAnnotationsFibonacciAnnotations: 'Fibonacci',
    toolbarAnnotationsFibonacciRetracement: 'Fib-retracement',
    toolbarAnnotationsFibonacciRetracementTrendBased: 'Fib baserat på trend',
    toolbarAnnotationsFillColor: 'Fyllnadsfärg',
    toolbarAnnotationsHorizontalLine: 'Horisontell linje',
    toolbarAnnotationsLineAnnotations: 'Trendlinjer',
    toolbarAnnotationsLineColor: 'Linjefärg',
    toolbarAnnotationsLineStrokeWidth: 'Linjens tjocklek',
    toolbarAnnotationsLineStyle: 'Linjestil',
    toolbarAnnotationsLock: 'Lås',
    toolbarAnnotationsMeasurerAnnotations: 'Mätverktyg',
    toolbarAnnotationsNote: 'Notering',
    toolbarAnnotationsParallelChannel: 'Parallell kanal',
    toolbarAnnotationsPriceRange: 'Prisspann',
    toolbarAnnotationsQuickDatePriceRange: 'Mäta',
    toolbarAnnotationsSettings: 'Inställningar',
    toolbarAnnotationsShapeAnnotations: 'Pilar',
    toolbarAnnotationsText: 'Text',
    toolbarAnnotationsTextAnnotations: 'Textnoteringar',
    toolbarAnnotationsTextColor: 'Textfärg',
    toolbarAnnotationsTextSize: 'Textstorlek',
    toolbarAnnotationsTrendLine: 'Trendlinje',
    toolbarAnnotationsUnlock: 'Lås upp',
    toolbarAnnotationsVerticalLine: 'Vertikal linje',
    toolbarRange1Month: '1M',
    toolbarRange1MonthAria: '1 månad',
    toolbarRange1Year: '1Å',
    toolbarRange1YearAria: '1 år',
    toolbarRange3Months: '3M',
    toolbarRange3MonthsAria: '3 månader',
    toolbarRange6Months: '6M',
    toolbarRange6MonthsAria: '6 månader',
    toolbarRangeAll: 'Alla',
    toolbarRangeAllAria: 'Alla',
    toolbarRangeYearToDate: 'ÅTD',
    toolbarRangeYearToDateAria: 'År till idag',
    toolbarSeriesTypeCandles: 'Ljus',
    toolbarSeriesTypeDropdown: 'Diagramtyp',
    toolbarSeriesTypeHighLow: 'Hög Låg',
    toolbarSeriesTypeHLC: 'HLC',
    toolbarSeriesTypeHollowCandles: 'Hollow Candles',
    toolbarSeriesTypeLine: 'Linje',
    toolbarSeriesTypeLineWithMarkers: 'Linje med markörer',
    toolbarSeriesTypeOHLC: 'OHLC',
    toolbarSeriesTypeStepLine: 'Steg Linje',
    toolbarZoomPanEnd: 'Panorera till slutet',
    toolbarZoomPanLeft: 'Panorera vänster',
    toolbarZoomPanRight: 'Panorera höger',
    toolbarZoomPanStart: 'Panorera till början',
    toolbarZoomReset: 'Återställ zoom',
    toolbarZoomZoomIn: 'Zooma in',
    toolbarZoomZoomOut: 'Zooma ut',
    tooltipPaginationStatus: '${index}[number] av ${count}[number]',
};
